export default (function A11yInputEnterClick() {
  Array.from(document.querySelectorAll("input[type='checkbox'], input[type='radio']")).forEach((element) => {
    element.addEventListener('keydown', (e) => {
      if(e.keyCode == 13) {
        element.click();
        e.preventDefault();
      }
    });
  });
})();